// extracted by mini-css-extract-plugin
export default {"joinBtn":"TimeEventsAgenda_joinBtn__CKCSf","replay":"TimeEventsAgenda_replay__AFKf6","joinBtnIcon":"TimeEventsAgenda_joinBtnIcon__yqfIe"};